import styled from 'styled-components'
import { colors, sizes, breakpoints, fonts } from '../components/css-variables'

/**
 * Handles styles for the core/image block.
 */
export default styled.div`
    img {
        margin-bottom: 0;
    }
    @media screen and ${breakpoints.laptopS} {
        :has(figure.alignright) {
            float: right;
            margin: 0.5em 0.5em 1em;
            clear: both;
        }

        :has(figure.alignleft) {
            float: left;
            margin: 0.5em 0.5em 1em;
            clear: both;
        }
    }

    @media screen and ${breakpoints.tabletS} {
        figure {
            display: table;
        }

        figcaption {
            display: table-caption;
            caption-side: bottom;
        }
    }

    figcaption {
        font-family: ${fonts.redHatText};
        font-weight: bold;
        font-size: ${sizes.s16};
        line-height: ${sizes.s22};
        color: ${colors.captionGrey};
        padding-top: 16px;
    }
`
